(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.InstagramPrivatePost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Instagram private post data',
            channelName: sourceDetails[sources.INSTAGRAM_INSIGHTS].name,
            postName: sourceDetails[sources.INSTAGRAM_INSIGHTS].postName,

            storageDimensions: [
                'post_id'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day',
                'dayOfWeek', 'hourOfDay',
                'postTagId',
                'hashtag',
                'keyword'
            ],

            fields: {
                post_id: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                company_id: {
                    dataType: dataType.STRING
                },
                company_name: {
                    dataType: dataType.STRING
                },
                presence_handle: {
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_reach: {
                    dataType: dataType.INTEGER
                },
                published_at: {
                    dataType: dataType.DATE
                },
                captured_at: {
                    dataType: dataType.DATE
                },
                message: {
                    dataType: dataType.STRING
                },
                post_url: {
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                num_carousel_children: {
                    dataType: dataType.INTEGER
                },
                num_carousel_photo_children: {
                    dataType: dataType.INTEGER
                },
                num_carousel_video_children: {
                    dataType: dataType.INTEGER
                },
                reach_organic: {
                    dataType: dataType.INTEGER
                },
                reach_paid: {
                    dataType: dataType.INTEGER
                },
                engagement_total: {
                    dataType: dataType.INTEGER
                },
                engagement_total_organic: {
                    dataType: dataType.INTEGER
                },
                engagement_total_paid: {
                    dataType: dataType.INTEGER
                },
                likes: {
                    dataType: dataType.INTEGER
                },
                likes_organic: {
                    dataType: dataType.INTEGER
                },
                likes_paid: {
                    dataType: dataType.INTEGER
                },
                comments: {
                    dataType: dataType.INTEGER
                },
                comments_organic: {
                    dataType: dataType.INTEGER
                },
                comments_paid: {
                    dataType: dataType.INTEGER
                },
                saves: {
                    dataType: dataType.INTEGER
                },
                saves_organic: {
                    dataType: dataType.INTEGER
                },
                saves_paid: {
                    dataType: dataType.INTEGER
                },
                shares: {
                    dataType: dataType.INTEGER
                },
                shares_organic: {
                    dataType: dataType.INTEGER
                },
                shares_paid: {
                    dataType: dataType.INTEGER
                },
                impressions: {
                    dataType: dataType.INTEGER
                },
                impressions_organic: {
                    dataType: dataType.INTEGER
                },
                impressions_paid: {
                    dataType: dataType.INTEGER
                },
                video_views: {
                    dataType: dataType.INTEGER
                },
                video_views_organic: {
                    dataType: dataType.INTEGER
                },
                video_views_paid: {
                    dataType: dataType.INTEGER
                },
                video_view_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                video_view_rate_by_impression_organic: {
                    dataType: dataType.NUMERIC
                },
                video_view_rate_by_impression_paid: {
                    dataType: dataType.NUMERIC
                },
                video_view_rate_by_reach: {
                    dataType: dataType.NUMERIC
                },
                video_view_rate_by_reach_organic: {
                    dataType: dataType.NUMERIC
                },
                video_view_rate_by_reach_paid: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_total: {
                    dataType: dataType.INTEGER
                },
                social_engagement_total_organic: {
                    dataType: dataType.INTEGER
                },
                social_engagement_total_paid: {
                    dataType: dataType.INTEGER
                },
                follows: {
                    dataType: dataType.INTEGER
                },
                profile_views: {
                    dataType: dataType.INTEGER
                },
                profile_interactions: {
                    dataType: dataType.INTEGER
                },
                profile_bio_link_clicks: {
                    dataType: dataType.INTEGER
                },
                profile_other_interactions: {
                    dataType: dataType.INTEGER
                },
                paid_link_clicks: {
                    dataType: dataType.INTEGER
                },
                total_spend: {
                    dataType: dataType.INTEGER
                },
                media_type: {
                    dataType: dataType.STRING
                },
                image_url: {
                    dataType: dataType.STRING
                },
                engagement_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_impression_organic: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_impression_paid: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_reach: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_reach_organic: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_reach_paid: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_reach_organic: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_reach_paid: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_impression_organic: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_impression_paid: {
                    dataType: dataType.NUMERIC
                },
                post_reach_rate_by_presence_reach_organic: {
                    dataType: dataType.NUMERIC
                },
                post_reach_rate_by_presence_reach_paid: {
                    dataType: dataType.NUMERIC
                },
                post_tag_ids: {
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost, // TODO: rename publicPost into just post
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
